import { Component, OnInit, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';

@Component({
	selector: 'component-evaluate',
	templateUrl: './component.evaluate.html',
	styleUrls: ['./component.evaluate.css']
})
export class ComponentEvaluate implements OnInit, AfterViewInit {

	@Input() context : string //追问内容
	@Input() myComment : string //顾问第一次点评
	@Input() myQuetionComment : string //顾问第二次点评
	@Input() excellentFlag : number //是否为优秀作业

	constructor(
		private route: ActivatedRoute,
		private router: Router,) {
		}
    ngOnInit() {

	}
		
	ngAfterViewInit(){
		
	}

	
}


// WEBPACK FOOTER //
// ./src/component/evaluate/component.evaluate.ts